<template>
  <div>
    <div class="mt-3 shadow p-5">
      <h1 class="font-bold">Filter</h1>
      <!-- filter ::{{ this.$store.state.main.bookingDetails.filter }} -->
      <vs-divider />
      <!-- ======================Price per day============================  -->
      <h5 class="font-bold mb-3">Price per day</h5>
      <div>
        <ul>

          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.price" vs-value="100-200" class="ml-0">RM 100 - RM 200</vs-radio>
            </div>
          </li>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.price" vs-value="200-300" class="ml-0">RM 200 - RM 300</vs-radio>
            </div>
          </li>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.price" vs-value="300-400" class="ml-0">RM 300 - RM 400</vs-radio>
            </div>
          </li>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.price" vs-value="400+" class="ml-0">RM 400 +</vs-radio>
            </div>
          </li>
        </ul>
        <vs-divider />
      </div>
      <!-- ================================================================= -->
      <!-- ======================Car category============================  -->
      <h5 class="font-bold mb-3">Car category</h5>
      <div>
        <ul>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.category" vs-value="Mini" class="ml-0">Mini</vs-radio>
            </div>
          </li>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.category" vs-value="Economy" class="ml-0">Economy</vs-radio>
            </div>
          </li>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.category" vs-value="Compact" class="ml-0">Compact</vs-radio>
            </div>
          </li>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.category" vs-value="Intermediate" class="ml-0">Intermediate</vs-radio>
            </div>
          </li>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.category" vs-value="Standard" class="ml-0">Standard</vs-radio>
            </div>
          </li>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.category" vs-value="Fullsize" class="ml-0">Fullsize</vs-radio>
            </div>
          </li>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.category" vs-value="Premium" class="ml-0">Premium</vs-radio>
            </div>
          </li>
          <li class="mb-2 flex items-center justify-between">
            <div class="flex justify-between w-full">
              <vs-radio v-model="filter.category" vs-value="Premium Elite" class="ml-0">Premium Elite</vs-radio>
            </div>
          </li>
        </ul>
        <vs-divider />
      </div>
      <!-- ================================================================= -->
      <vs-button @click="resetFilter" color="primary" type="flat">Reset Filter</vs-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { helperMixin } from "@/mixin/helperMixin";

export default {
  mixins: [helperMixin],
  data() {
    return {
      test: this.$store.state.main.bookingDetails.filter,
      isFilterSidebarActive: true,
      settings: {
        maxScrollbarLength: 100,
        wheelSpeed: 0.6,
      },
      filter: {
        price: "",
        category: "",
      },
    };
  },
  methods: {
    resetFilter() {
      this.filter.price = "";
      this.filter.category = "";
      this.$store.state.main.bookingDetails.filter = "";
      this.$emit("fetchApi");
    },
    cancel() {
      this.$router.go(-1);
    },
  },
  computed: {
    ...mapState({
      storeFilter: (state) => state.main.bookingDetails.filter,
    }),
    ...mapGetters({
      scrollbarTag: "main/scrollbarTag",
    }),
  },
  watch: {
    filter: {
      handler(newValue) {
        this.$store.state.main.bookingDetails.filter = newValue;
      },
      deep: true,
    },
    storeFilter: {
      handler(newValue) {
        this.$emit("fetchApi"); // Emit the event to fetch API
        ("ToDo");
      },
      deep: true,
      immediate: true,
    },
  },
  created() { },
};
</script>
